import Cookie from "js-cookie";
import { REGION_COOKIE } from "../../../common/constants/Constants";

const REGION_TO_COOKIE_VALUE: {[s: string]: string} = {
    US: "AMER",
    Africa: "AFRICA",
    Europe: "EUR",
    Asia: "APAC",
    Middleeast: "MIDEAST",
    Canada: "CANADA",
    Japan: "JAPAN"
};

function setRegionPreferenceCookie(region: string): void {
    const regionValue = REGION_TO_COOKIE_VALUE[region] || REGION_TO_COOKIE_VALUE["US"];

    Cookie.set(REGION_COOKIE, regionValue, {
        domain: ".bloomberg.com"
    });
}

export default setRegionPreferenceCookie;
